import React from "react"
import Header from "./components/Header.jsx"
import Footer from "./components/Footer.jsx"
import HomeView from "./views/HomeView.jsx"
import AuditView from "./views/AuditView.jsx"
import LaunchView from "./views/LaunchView.jsx"
import ShopifyView from "./views/ShopifyView.jsx"

// Marketing surface root. Branches on `page` prop (passed from the
// HAML view via data-page on #marketing-root):
//   "home"   → full marketing page (Hero / Counters / WhatItDoes /
//              HowItWorks / Pricing / FAQ)
//   "audit"  → cold-email-tuned single-funnel landing (Phase 1d).
//              No anchor links in the header since the audit page
//              doesn't have How-It-Works / Pricing / FAQ sections.
//   "launch" → 50%-off launch promo for first 100 webshops
//              (2026-05-20). Scarcity-framed register, How-It-Works
//              + Pricing + FAQ kept (so header anchors stay).
//   "shopify" → Shopify-merchant landing (2026-07-17). App Store /
//              PH destination; install-first CTA, anchors kept.
export default function App({ priceCents = 9900, page = "home", promoCode = null, spotsRemaining = null, spotsTotal = null, appStoreUrl = null }) {
  const showAnchorLinks = page !== "audit"

  const view = () => {
    switch (page) {
      case "audit":
        return <AuditView />
      case "launch":
        return (
          <LaunchView
            priceCents={priceCents}
            promoCode={promoCode || "SAVE50"}
            spotsRemaining={spotsRemaining}
            spotsTotal={spotsTotal || 100}
          />
        )
      case "shopify":
        return <ShopifyView priceCents={priceCents} appStoreUrl={appStoreUrl} />
      default:
        return <HomeView priceCents={priceCents} />
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header showAnchorLinks={showAnchorLinks} />
      <main className="flex-1">{view()}</main>
      <Footer />
    </div>
  )
}
